/* SP FIX Sep20 v6 — Salty Paws

   THE BIG ONE, found 2026-09-20: on a real mouse click, size and colour buttons did not
   respond at all. Every product, every desktop shopper.
   Cause: the size and colour rows are Swiper carousels, and Swiper runs with its default
   touchStartPreventDefault = true (plus preventClicks and preventClicksPropagation).
   Swiper calls preventDefault on pointerdown, which cancels the browser's native label to
   radio activation, so the radio is never checked and nothing happens. Scripted clicks
   still worked, which is why it hid for so long. Proven live: three real clicks on XL did
   nothing; after switching those three params off, one click selected XL.
   Fix: turn those three params off on every variant swiper, on load, on every update and
   again on pointerdown just before Swiper sees it. Swipe and drag still work.

   ALSO FIXES
   a. The theme works out availability in ONE direction only. Pick a SIZE first and every
      colour still reports available, so nothing warns the shopper.
   b. Picking a colour not made in the chosen size silently resets the size, with no
      message. 4XL + Sand -> size jumps to S.
   c. A ?variant= link can land a shopper on a colour made in one size, so most sizes are
      crossed out on arrival and the page looks broken.

   DESIGN RULE: this script TELLS, it never CHOOSES. It restores normal clicking, adds the
   unavailable mark, and adds a plain-English line. It never changes the shopper's colour
   or size, never removes an unavailable mark, and never touches price or listing data.
   If it cannot map the page to the variant data with certainty it does nothing at all.

   REVERT: delete this file and the script line in layout/theme.liquid. */
(function () {
  var cache = {};
  var pending = null;
  var movedNotice = null;

  /* ---- the click fix ---- */
  function patchSwipers(root) {
    var els = (root || document).querySelectorAll('.variant-swiper');
    for (var i = 0; i < els.length; i++) {
      var s = els[i].swiper;
      if (!s || !s.params) continue;
      s.params.touchStartPreventDefault = false;
      s.params.preventClicks = false;
      s.params.preventClicksPropagation = false;
    }
  }
  document.addEventListener('pointerdown', function (ev) {
    if (!ev.target || !ev.target.closest) return;
    var sw = ev.target.closest('.variant-swiper');
    if (sw && sw.swiper && sw.swiper.params) {
      sw.swiper.params.touchStartPreventDefault = false;
      sw.swiper.params.preventClicks = false;
      sw.swiper.params.preventClicksPropagation = false;
    }
  }, true);
  setInterval(function () { patchSwipers(); }, 500);

  /* ---- availability + messages ---- */
  function getData(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function handleOf(picker) {
    var u = (picker.dataset.productUrl || '').split('?')[0];
    var m = u.match(/\/products\/([^\/]+)\/?$/);
    return m ? m[1] : null;
  }

  function labelOf(input) {
    return (input.getAttribute('aria-label') || input.value || '').trim();
  }

  function sizeFieldsetIn(picker) {
    var all = picker.querySelectorAll('fieldset.variant-option');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-is-size-option') === 'true') return all[i];
    }
    return null;
  }

  function checkedIn(fs) {
    if (!fs) return null;
    var c = fs.querySelector('input[type="radio"]:checked');
    return c ? labelOf(c) : null;
  }

  function build(picker, data) {
    if (!data || !data.options || !data.variants || !data.variants.length) return null;
    var optValues = data.options.map(function (o) {
      return (typeof o === 'string' ? null : o.values) || null;
    });
    if (optValues.indexOf(null) !== -1) return null;

    var fieldsets = [].slice.call(picker.querySelectorAll('fieldset.variant-option'));
    if (!fieldsets.length) return null;

    var idx = [], used = {};
    for (var f = 0; f < fieldsets.length; f++) {
      var radios = fieldsets[f].querySelectorAll('input[type="radio"]');
      if (!radios.length) return null;
      var vals = [];
      for (var i = 0; i < radios.length; i++) vals.push(labelOf(radios[i]));
      var found = -1;
      for (var o = 0; o < optValues.length; o++) {
        if (used[o]) continue;
        var ok = true;
        for (var v = 0; v < vals.length; v++) {
          if (optValues[o].indexOf(vals[v]) === -1) { ok = false; break; }
        }
        if (ok) { found = o; break; }
      }
      if (found === -1) return null;
      used[found] = true;
      idx.push(found);
    }

    var sizeFs = null, colourFs = null, sizePos = -1, colourPos = -1;
    for (var a = 0; a < fieldsets.length; a++) {
      if (fieldsets[a].getAttribute('data-is-size-option') === 'true') {
        if (!sizeFs) { sizeFs = fieldsets[a]; sizePos = idx[a]; }
      } else if (!colourFs) { colourFs = fieldsets[a]; colourPos = idx[a]; }
    }
    return {
      fieldsets: fieldsets, idx: idx, variants: data.variants, width: data.options.length,
      sizeFs: sizeFs, colourFs: colourFs, sizePos: sizePos, colourPos: colourPos
    };
  }

  function exists(variants, cand) {
    for (var i = 0; i < variants.length; i++) {
      var vo = variants[i].options, m = true;
      for (var p = 0; p < cand.length; p++) {
        if (cand[p] == null) continue;
        if (vo[p] !== cand[p]) { m = false; break; }
      }
      if (m) return true;
    }
    return false;
  }

  function mark(ctx) {
    var sel = new Array(ctx.width);
    for (var a = 0; a < ctx.fieldsets.length; a++) sel[ctx.idx[a]] = checkedIn(ctx.fieldsets[a]);
    for (var b = 0; b < ctx.fieldsets.length; b++) {
      var my = ctx.idx[b];
      var rs = ctx.fieldsets[b].querySelectorAll('input[type="radio"]');
      for (var k = 0; k < rs.length; k++) {
        var cand = sel.slice();
        cand[my] = labelOf(rs[k]);
        if (!exists(ctx.variants, cand) && rs[k].getAttribute('data-option-available') !== 'false') {
          rs[k].setAttribute('data-option-available', 'false');
        }
      }
    }
  }

  function sizesFor(ctx, colour) {
    if (!ctx.sizeFs) return [];
    var all = [].slice.call(ctx.sizeFs.querySelectorAll('input[type="radio"]')).map(labelOf);
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var cand = new Array(ctx.width);
      cand[ctx.colourPos] = colour;
      cand[ctx.sizePos] = all[i];
      if (exists(ctx.variants, cand)) out.push(all[i]);
    }
    return out;
  }

  function joinList(a) {
    if (a.length === 1) return a[0];
    if (a.length === 2) return a[0] + ' and ' + a[1];
    return a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
  }

  function clearNotice() {
    var n = document.getElementById('sp-size-notice');
    if (n && n.parentNode) n.parentNode.removeChild(n);
  }

  function showNotice(ctx, text) {
    var existing = document.getElementById('sp-size-notice');
    if (existing && existing.textContent === text && existing.isConnected) return;
    clearNotice();
    if (!ctx.sizeFs || !ctx.sizeFs.parentNode) return;
    var d = document.createElement('div');
    d.id = 'sp-size-notice';
    d.setAttribute('role', 'status');
    d.style.cssText = 'margin:10px 0 4px;padding:10px 12px;border-left:3px solid #d33;background:rgba(221,51,51,.06);font-size:14px;line-height:1.45;';
    d.textContent = text;
    ctx.sizeFs.parentNode.insertBefore(d, ctx.sizeFs.nextSibling);
  }

  function deadEndMessage(ctx) {
    if (!ctx.sizeFs || !ctx.colourFs) return null;
    var totalSizes = ctx.sizeFs.querySelectorAll('input[type="radio"]').length;
    if (totalSizes < 2) return null;
    var current = checkedIn(ctx.colourFs);
    if (!current) return null;
    var mine = sizesFor(ctx, current);
    if (mine.length > 1) return null;
    var msg = mine.length === 1
      ? current + ' is only made in ' + mine[0] + '.'
      : current + ' is not currently made in any size.';
    var full = [];
    var colours = [].slice.call(ctx.colourFs.querySelectorAll('input[type="radio"]'));
    for (var j = 0; j < colours.length; j++) {
      var nm = labelOf(colours[j]);
      if (nm === current) continue;
      if (sizesFor(ctx, nm).length === totalSizes) full.push(nm);
      if (full.length === 3) break;
    }
    if (full.length) msg += ' ' + joinList(full) + ' come in every size.';
    return msg;
  }

  function handleNotice(ctx) {
    if (pending) {
      var nowSize = checkedIn(ctx.sizeFs);
      var nowColour = checkedIn(ctx.colourFs);
      if (Date.now() - pending.t > 8000) {
        pending = null;
      } else if (nowColour === pending.colour && nowSize && nowSize !== pending.sizeBefore) {
        var avail = sizesFor(ctx, pending.colour);
        var largest = avail.length ? avail[avail.length - 1] : null;
        var msg = pending.colour + ' is not made in ' + pending.sizeBefore +
                  ', so your size moved to ' + nowSize + '.';
        if (largest) msg += ' In ' + pending.colour + ', sizes go up to ' + largest + '.';
        movedNotice = msg;
        pending = null;
      }
    }
    var text = movedNotice || deadEndMessage(ctx);
    if (text) showNotice(ctx, text); else clearNotice();
  }

  document.addEventListener('click', function (ev) {
    var node = ev.target;
    if (!node || !node.closest) return;
    var fs = node.closest('fieldset.variant-option');
    if (!fs) return;
    var picker = fs.closest('variant-picker');
    if (!picker) return;
    var sizeFs = sizeFieldsetIn(picker);

    movedNotice = null;

    if (fs === sizeFs) { pending = null; return; }

    var radio = null;
    if (node.tagName === 'INPUT') radio = node;
    if (!radio) {
      var lab = node.closest('label');
      if (lab) radio = lab.querySelector('input[type="radio"]') ||
                        (lab.htmlFor ? document.getElementById(lab.htmlFor) : null);
    }
    if (!radio) return;

    var before = checkedIn(sizeFs);
    if (!before) { pending = null; return; }
    pending = { colour: labelOf(radio), sizeBefore: before, t: Date.now() };
  }, true);

  function run() {
    patchSwipers();
    var pickers = document.querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i++) {
      (function (p) {
        var h = handleOf(p);
        if (!h) return;
        getData(h).then(function (d) {
          try {
            var ctx = build(p, d);
            if (!ctx) return;
            mark(ctx);
            handleNotice(ctx);
          } catch (e) {}
        });
      })(pickers[i]);
    }
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(run, 80); }

  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('variant:update', schedule);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { subtree: true, childList: true });
  }
  setInterval(function () { if (pending) run(); }, 400);
  schedule();
})();
